import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from '../../lib/SelectAdvancedFilter';
import { useCompaniesContext } from '../CompaniesContext';
import { MONTHS } from '../create/constants';

const CompaniesFiltersShopsSchedule = () => {
  const { filters, setFilters } = useCompaniesContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, shop_months: values });
  };

  return (
    <SelectAdvancedFilter
      placeholder={'Shops Schedule'}
      className={classNames({ active: Boolean(filters.shop_months?.length) })}
      options={MONTHS}
      defaultValue={filters?.shop_months ?? []}
      onSelect={handleSelect}
    />
  );
};

export default CompaniesFiltersShopsSchedule;
